import { render, staticRenderFns } from "./OwnerListUpdated.vue?vue&type=template&id=57273bca&scoped=true&lang=html&"
import script from "./OwnerListUpdated.vue?vue&type=script&lang=js&"
export * from "./OwnerListUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57273bca",
  null
  
)

export default component.exports